import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import Link from './../elements/link';
import { CONSTS } from './../elements/_constants';
type WidgetComponentProps = {
    className?:string,
    title?: string,
    iconUrl?: string,
    to?: any,
    href?: string,
    style?:CSSProperties,
    onClick?: any,
}
const WidgetComponent = (props: WidgetComponentProps) => {
    return(
        <Link className={props.className} to={props.to} href={props.href} onClick={props.onClick} style={{...props.style}}>
            {props.iconUrl && <img className="_icon" src={props.iconUrl}/>}
            {props.title && <div className="_title">{props.title}</div>}
        </Link>
    )}

const Widget = styled(WidgetComponent)`
    border: 1px solid rgba(63,63,68,0.05);
    border-radius: ${CONSTS.border.radius2};
    background: white;
    flex: 1 1 calc(20% - 20px);
    margin:7px;
    height: 170px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    transition: ease background .25s,ease color .25s;
    color: ${CONSTS.colors.primary};
    @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) { 
        width: 100%;
    }
    ._icon {
        width: 45px;
        fill: ${CONSTS.colors.primary};
    }
    ._title {
        font-size: 16px;
        padding-top: 18px;
        font-family: ${CONSTS.fonts.primary.medium};
    }
    &:hover {
        background: ${CONSTS.colors.primaryLight};
    }
    &:active {
        background: ${CONSTS.colors.primary};
        color: white;
    }
`

export default Widget;